import { FC } from 'react';
import { Image } from '@chakra-ui/react';

import { PlansVariant } from '__generated__/GQL';
import SunshineCard from 'components/_core/SunshineCard';

import Fireworks from './assets/Fireworks@2x.png';
import WavingFlower from './assets/WavingFlower@2x.png';
import locales from './locales';

const variantToIllustration: Record<PlansVariant, string> = {
  [PlansVariant.Solo]: WavingFlower,
  [PlansVariant.Team]: Fireworks,
};

interface BoxChoseVariantProps {
  variant: PlansVariant;
  setVariant: (variant: PlansVariant) => void;
}

const BoxChoseVariant: FC<BoxChoseVariantProps> = ({ setVariant, variant }) => (
  <SunshineCard
    onClick={() => setVariant(variant)}
    title={locales[variant].title}
  >
    <SunshineCard.Content marginTop="space-16">
      <SunshineCard.Text>{locales[variant].subtitle}</SunshineCard.Text>

      <SunshineCard.Button icon="arrow-right" variant="inline-primary">
        {locales.seeOffer}
      </SunshineCard.Button>
    </SunshineCard.Content>

    <SunshineCard.Slot name="action">
      <Image boxSize="118px" src={variantToIllustration[variant]} />
    </SunshineCard.Slot>
  </SunshineCard>
);

export default BoxChoseVariant;
